import { LodgmentSection } from '../../lodgmentSections/LodgmentSection';

export const getLodgmentSectionHeatingSystem = (lodgmentSection: LodgmentSection) =>
  lodgmentSection.heatingSystem || lodgmentSection.defaultHeatingSystem;
